import RegistrationFormData, {
    RegisterMutationData
} from '../interfaces/RegistrationFormData';

export const transformFormData = (
    formData: RegistrationFormData
): RegisterMutationData => ({
    ...formData,
    situation: formData.situation?.id,
    consent__insights__24:
        formData.consent__insights__24 === 'yes' ? true : false
});
